import React from 'react';
import styled from 'styled-components';
import { IconBase } from '../Base';
const IconBaseCsv = styled(IconBase) `
  --icon-color: #a9acb6;
`;
export const IconCsv = (props) => {
    return (React.createElement(IconBaseCsv, { ...props },
        React.createElement("rect", { x: "4", y: "4", width: "12", height: "12", rx: "3", strokeWidth: "1.5", style: { stroke: 'var(--icon-color)' } }),
        React.createElement("path", { d: "M10 16L10 4", strokeWidth: "1.5", style: { stroke: 'var(--icon-color)' } }),
        React.createElement("path", { d: "M16 8L4 8", strokeWidth: "1.5", style: { stroke: 'var(--icon-color)' } }),
        React.createElement("path", { d: "M16 12L4 12", strokeWidth: "1.5", style: { stroke: 'var(--icon-color)' } })));
};
//# sourceMappingURL=Csv.js.map